var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCallGms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 96,
    viewBox: "0 0 136 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5347_1678)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.2386 79.7191C28.4309 78.1224 26.471 75.2277 24.5513 69.7511C22.2255 63.0818 20.7707 57.5361 20.2372 48.901C19.7306 40.5667 20.1157 35.8005 21.9664 27.6544C24.0541 18.455 27.5185 15.7262 29.4007 14.9146C31.6474 13.9421 33.671 13.9608 36.0223 14.2822C37.3486 14.4752 38.6541 14.7896 39.9224 15.2215C40.0503 15.2636 40.1701 15.3018 40.2773 15.3355C40.9188 15.5345 41.89 15.8369 42.4743 16.9463C42.8661 17.6847 42.9905 18.5973 43.0929 20.1299C43.3047 23.2706 42.3283 28.9865 41.5678 31.5453C41.0531 33.268 40.7142 34.406 39.9124 35.3098C38.9725 36.367 37.7143 36.7111 36.2847 37.0192C36.0165 37.0773 35.7557 37.1288 35.5028 37.179C33.9772 37.4798 33.5853 37.61 33.2636 38.1764C32.6189 39.3163 31.6252 43.5267 31.9179 48.28C32.2105 53.0333 33.7082 56.9241 34.49 57.9805C34.8939 58.5268 35.3099 58.6074 36.9125 58.7241C37.1423 58.7408 37.3791 58.7571 37.6224 58.7791C39.2605 58.9189 40.5008 59.0897 41.5362 60.0042L41.5418 60.0091C42.4429 60.805 42.8679 61.876 43.5747 63.6474C44.4964 65.9581 46.2918 71.5838 46.4685 74.738C46.5551 76.2716 46.545 77.1923 46.2468 77.9722C45.7979 79.1465 44.8708 79.5589 44.2557 79.8398C44.1533 79.8862 44.0407 79.9367 43.9179 79.9947C42.7093 80.5714 41.45 81.0361 40.156 81.3828C37.8664 81.9812 35.8586 82.2368 33.5064 81.5389C32.2929 81.1869 31.1755 80.5646 30.2386 79.7191Z",
    fill: "#EA9D00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4293 14.9254C29.392 14.9411 29.3546 14.957 29.3171 14.9732C27.4349 15.7848 23.9706 18.5137 21.8829 27.713C20.0322 35.8591 19.6471 40.6253 20.1537 48.9597C20.6872 57.5947 22.142 63.1404 24.4678 69.8097C26.3874 75.2863 28.3473 78.1811 30.1551 79.7777C31.092 80.6233 32.2093 81.2455 33.4229 81.5975C33.6035 81.6511 33.7821 81.6991 33.959 81.7417C29.5965 72.8878 26.5652 61.119 25.7781 48.0814C25.0257 35.617 26.449 24.057 29.4293 14.9254Z",
    fill: "#559BDC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 48,
    r: 4,
    fill: "#C9DDEF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 47.5,
    r: 2.5,
    fill: "#C9DDEF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.5,
    cy: 47.5,
    r: 22.5,
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 48,
    r: 2.5,
    fill: "#004D8F",
    stroke: "#004D8F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 48,
    r: 2.5,
    fill: "#004D8F",
    stroke: "#004D8F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 48,
    r: 2.5,
    fill: "#004D8F",
    stroke: "#004D8F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5347_1678"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 136,
    height: 96,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallGms);
export default __webpack_public_path__ + "static/media/call_gms.595bee7a090bd5555907e147dd4e32e4.svg";
export { ForwardRef as ReactComponent };